import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AdviceSection from '../common/AdviceSection';
import SelectEconomic from '../common/select-filters/SelectEconomic';
import DatasetSelectTrend from '../common/select-filters/DatasetSelectTrend';
import SpiderChart from '../common/charts/SpiderChart';
import SpiderBarChart from '../common/charts/SpiderBarChart';
import Methodology from '../common/Methodology';
import Related from '../common/Related';

import UrlChanger from '../common/urlChanger/UrlChanger';

import { workerInvolvementTabs } from '../../model/subMenuTabs';

import { setCountry1, setCountry2, setCountry3 } from '../../actions/';

const WorkerInvolvement = props => {

	const currentPath = '/osh-steering/social-dialogue/worker-involvement/';
	const indicatorTabs = workerInvolvementTabs[0]

	let split = 'esener';
	if (props.split)
	{
		split = props.split;
	}

	// Get global state for the selects
	const { selectCountry, selectCountry2, selectCountry3, selectedByUser, lockedCountry } = useSelector((state) => state.selectCountries);
	const [countryLocked, setCountryLocked] = useState(lockedCountry);
	const [chartLegend, setChartLegend] = useState('');
	const [dataset, setDataset] = useState(split);
	const [chartDataset, setChartDataset] = useState('');
	const [spiderChart, setSpiderChart] = useState(true);
	
	// Hook for the dispatchs
	const dispatch = useDispatch();

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L22015 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		if (selectedByUser) {
			return null
		} else {
			if (props.country1 != undefined && props.country1 != '') {
				dispatch(setCountry1(props.country1))
			}
		}

		if (props.country2 != undefined && props.country2 != '') {
			dispatch(setCountry2(props.country2))
		}

		if (props.country3 != undefined && props.country3 != '') {
			dispatch(setCountry3(props.country3))
		}
	}, [])

	const handleSearch = (callbackCountry1) => {
		if (selectedByUser) {
			setCountryLocked(callbackCountry1);
		} else {
			dispatch(setCountry1(callbackCountry1));
		}
	}

	const handleSearch2 = (callbackCountry2) => {
		dispatch(setCountry2(callbackCountry2));
	}

	const handleSearch3 = (callbackCountry3) => {
		dispatch(setCountry3(callbackCountry3));
	}

	const callbackSelectedSurvey = (callback) => {
		setDataset(callback);
		setChartDataset('');
	}

	const callbackChartLegend = (legend) => {
		setChartLegend(legend);
	}

	const handleDefaultDataset = (dataset, indicator, label) => {
		setChartDataset( { id: dataset, label: label } );
	}

	const handleDatasetChange = (dataset, indicator, label) => {
		setChartDataset( { id: dataset, label: label } );
	}

	// Change from Spider Chart to Column Chart and Vice Versa
	const handleSpiderButton = () =>
	{
		setSpiderChart(!spiderChart);
	}

	const selectCountry1 = selectedByUser ? countryLocked : selectCountry;

	return(
		<div className="worker-involvement">
			<AdviceSection literals={ props.literals } section={["osh-steering","worker-involvement"]} methodologyData={{section: 'osh-steering', subsection: 'Worker involvement', indicator: 75}} />

			<form className="compare--block--form">

				<div>
					<SelectEconomic 
						handleSearch={ handleSearch } 
						handleSearch2={ handleSearch2 } 
						handleSearch3={ handleSearch3 } 
						literals={ props.literals }
						selectedCountry1={ selectCountry1 }
						selectedCountry2={ selectCountry2 }
						selectedCountry3={ selectCountry3 }
						charts={ [ indicatorTabs.chartType.find((element) => element.type == dataset).chart ] }
						indicator={ indicatorTabs.chartType.find((element) => element.type == dataset).chartIndicator }
					/>

				</div>

				<div className="line background-main-light"></div>

				<DatasetSelectTrend
					selectedIndicator={ dataset }
					literals={ props.literals }
					chartType={ indicatorTabs.chartType }
					callbackSelectedSurvey={ callbackSelectedSurvey }
					handleDatasetChange1={ handleDatasetChange }
					handleDefaultDataset= { handleDefaultDataset }
					showSourceSelect={true}
					showAnswerSelect={false}
					yearOnly={true}
				/>

				<div className="line background-main-light"></div>

				<div className="container section--page card--grid xxs-w1 xs-w1 w1 center-text">
					<div className="card--block--chart with-filters">
						<div className='card--btn-wrapper'>
							<div className='btn-trend-container'>
								<a className="btn-default btn-main-color ng-binding btn-trend" onClick={ handleSpiderButton }>{spiderChart ? props.literals["L20311"] : props.literals["L20641"]}</a>
							</div>
						</div>
						<div className="chart--block">
							<div className="chart--wrapper spider-chart" >
								<UrlChanger  
									currentLocation={ currentPath }
									currentSplit={ dataset }
									lockedCountry={ lockedCountry }
								/>

								{ spiderChart ? 
									<SpiderChart
										literals={ props.literals }
										tabIndicator={ indicatorTabs.literalTab }
										selectCountry1={ selectCountry1 }
										selectCountry2={ selectCountry2 }
										selectCountry3={ selectCountry3 }
										showDataLabel={ true }
										colors={ ['#f6a400','#529FA2','#7b7b7d','#003399'] }
										chartType={ indicatorTabs.chartType }
										callbackLegend={ callbackChartLegend }
										datasetSource={ dataset }
										datasetID={ chartDataset.id }
										exportingEnabled={ true }
									/>
								:
									<SpiderBarChart 
										literals={ props.literals }
										type={ "column" }
										chartType={ indicatorTabs.chartType }
										datasetSource={ dataset }
										datasetID={ chartDataset.id }
										selectCountry1={ selectCountry1 }
										selectCountry2={ selectCountry2 }
										selectCountry3={ selectCountry3 }
										percentage={"%"}
										colors={ ['#ffae00','#529FA2','#7B7B7D'] }
									/>
								}
							</div>
						</div>
						<div className="chart-legend">
							{ props.literals[`L${chartLegend}`] } 
						</div>						
					</div>
				</div>
			</form>
			<Methodology literals={ props.literals } section={'Worker involvement'} dataset={ dataset } />
			<Related literals={ props.literals } section={["working-conditions-preventions","worker-involvement"]} />
		</div>
	)
}
WorkerInvolvement.displayName = 'WorkerInvolvement';
export default WorkerInvolvement;